import { useCallback, useContext } from "react";
import { useQuery } from "react-query";
import type { IGetAllSuppliersByParkingArealIdParams } from "../domain";
import { UseQueryProps } from "../../interfaces";
import { apiServiceContext } from "../../api-service-context";
import { QueryKeys } from "../query-keys";

export const useGetSuppliers = <TData = any, TError = any>(
  params: IGetAllSuppliersByParkingArealIdParams,
  queryOptions: UseQueryProps<TData, TError> = {}
) => {
  const { ordersApiService } = useContext(apiServiceContext);
  const queryFn = useCallback(
    () =>
      ordersApiService.createCancellableRequest((cancelToken) =>
        ordersApiService.getAllSuppliersByParkingArealId(params, cancelToken)
      ),
    [ordersApiService, params]
  );

  return useQuery(QueryKeys.suppliers(params), queryFn, queryOptions);
};
